export enum TICKET_TRANSFER_STATUS{
  NONE,
  OPEN,
  CLOSED,
  NOT_OPEN,
  NO_AVAILABLE_TRANSFERS
}